export const siteConfig = {
  name: "Enhance Companies",
  tagline: "Most profitable producers in the industry",
  description: "Empowering insurance professionals with industry-leading technology, comprehensive training programs, and top carrier partnerships to accelerate growth and maximize earning potential",
  
  contact: {
    phone: "(424) 244-6608",
  },
  
  navigation: [
    { name: "Home", href: "/" },
    { name: "Lead Catalog", href: "/lead-catalog" },
    { name: "Carriers", href: "/carriers" },
    { name: "Technology", href: "/technology" },
    { name: "Services", href: "/services" },
  ],
  
  companyDropdown: [
    { name: "About", href: "/about" },
    { name: "Contact", href: "/contact" },
    { name: "Services Contact", href: "/services/contact" },
  ],
  
  carriers: [
    "Aetna",
    "American Home Life", 
    "American Amicable",
    "Americo",
    "Corebridge (AIG)",
    "Transamerica",
    "Liberty Bankers",
    "Royal Neighbors",
    "Foresters",
    "Combined Insurance",
    "F&G",
    "Athene",
    "Allianz",
    "Mutual of Omaha"
  ],
  
  licenseStatuses: [
    "Unlicensed",
    "Studying",
    "Licensed <1yr",
    "1-3yrs",
    "3-5yrs", 
    "5+yrs"
  ],
  
  experienceLevels: [
    "New",
    "Some",
    "Experienced",
    "Leader"
  ],
  
  states: [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
    'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
    'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
    'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
    'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
    'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
    'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
  ]
};